export function modals() {
    isPrimaryModals();

    let modals = document.getElementsByClassName('modal');
    if (modals.length == 0) return;

    let modal = modals[0] as HTMLElement;
    let modalWrapper = document.getElementsByClassName('modal-wrapper')[0] as HTMLElement;
    let closeTriggerElts = document.getElementsByClassName('modal-close');

    let closeModal = function () {
        modalWrapper.style.display = 'none';
        document.getElementsByTagName("body")[0].classList.remove("modal-open");
    }

    for (var i = 0; i < closeTriggerElts.length; i++) {
        closeTriggerElts[i].addEventListener('click', closeModal);
    }

    // Close modal on outside click
    modalWrapper.addEventListener('click', function (e) {
        if (!modal.contains(e.target as any)) {
            closeModal();
        }
    });   

}

function isPrimaryModals() {
    let isPrimaryModals = document.getElementsByClassName('mark-primary-modal');

    for (let i = 0; i < isPrimaryModals.length; i++) {
        isPrimaryModals[i].addEventListener('click', function (e) {
            let target = e.target as Element;
            if (target === isPrimaryModals[i]) {
                isPrimaryModals[i].classList.add('modal-closed');
            }
        });
    }
}


